<template>
    <!-- If there is a transaction, show its result -->
    <MellonWebECRTransactionResultLabel v-if="transaction"
                                        :transaction="transaction" />
    <!-- If there is no transaction, show the intent result if the intent is complete -->
    <MellonWebECRIntentResultLabel v-else-if="intentIsComplete"
                                   :intent="intent" />
    <!-- Otherwise show the intent status -->
    <MellonWebECRIntentStatusLabel v-else
                                   :intent="intent" />
</template>

<script>
import MellonWebECRIntentResultLabel
    from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRIntentResultLabel';
import MellonWebECRIntentStatus from '@/lib/PaymentMethods/MellonWebECR/Enums/MellonWebECRIntentStatus';
import MellonWebECRIntentStatusLabel
    from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRIntentStatusLabel';
import MellonWebECRTransactionResultLabel
    from '@/epos/vue/modals/Payment/PaymentMethods/MellonWebECR/MellonWebECRTransactionResultLabel';

export default {
    components: {
        MellonWebECRIntentStatusLabel,
        MellonWebECRIntentResultLabel,
        MellonWebECRTransactionResultLabel,
    },

    props: {
        /**
         * @type {MellonWebECRTransactionIntent}
         */
        intent: {
            type: Object,
            required: true,
        },

        /**
         * @type {?MellonWebECRTransaction}
         */
        transaction: {
            type: Object,
            default: null,
        },
    },

    computed: {
        intentIsComplete() {
            return this.intent.Status === MellonWebECRIntentStatus.COMPLETED;
        },
    },
};
</script>
